import React, { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import Swal from 'sweetalert2';

const ContactForm = () => {
  const [forms, setForms] = useState({
    full_name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [validator] = useState(new SimpleReactValidator({
    className: 'errorMessage',
  }));

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  const changeHandler = e => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessageFor(e.target.name);
  };

  const submitHandler = async e => {
    e.preventDefault();
    if (validator.allValid()) {
      setLoading(true);
      setError('');
      try {
        await axios.post(`${apiUrl}/api/contacts`, forms);

        Swal.fire({
          icon: 'success',
          title: 'Message Sent!',
          text: 'Your message has been successfully sent.',
          confirmButtonColor: 'darkblue',
        });

        setForms({
          full_name: '',
          email: '',
          phone: '',
          message: ''
        });
      } catch (err) {
        setError('Something went wrong. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      validator.showMessages();
    }
  };

  // Base color
  const brandBlue = 'darkblue';

  // Updated inline styles
  const formStyles = {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '40px 30px',
    borderRadius: '12px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 20px rgba(0, 0, 139, 0.25)',
    border: '1px solid rgba(0, 0, 139, 0.3)',
    transition: 'box-shadow 0.3s ease, border 0.3s ease',
  };

  const inputStyles = {
    width: '100%',
    padding: '12px 15px',
    margin: '8px 0',
    borderRadius: '6px',
    border: '1px solid rgba(0, 0, 139, 0.3)',
    fontSize: '16px',
    outline: 'none',
    backgroundColor: '#f9f9ff',
    transition: 'all 0.3s ease',
  };

  const textareaStyles = {
    ...inputStyles,
    minHeight: '120px',
    resize: 'vertical',
  };

  const buttonStyles = {
    padding: '12px 25px',
    background: 'linear-gradient(90deg, darkblue 0%, #4da3ff 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    cursor: loading ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 10px rgba(0, 0, 139, 0.4)',
  };

  const errorStyles = {
    color: 'red',
    fontSize: '14px',
    marginTop: '-5px',
    marginBottom: '10px'
  };

  const focusEffect = (e) => {
    e.target.style.borderColor = brandBlue;
    e.target.style.boxShadow = '0 0 6px rgba(0, 0, 139, 0.3)';
    e.target.style.backgroundColor = '#fff';
  };

  const blurEffect = (e) => {
    e.target.style.borderColor = 'rgba(0, 0, 139, 0.3)';
    e.target.style.boxShadow = 'none';
    e.target.style.backgroundColor = '#f9f9ff';
  };

  return (
    <form onSubmit={submitHandler} style={formStyles}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px'}}>
        <div style={{ flex: '1 1 48%' }}>
          <input
            value={forms.full_name}
            type="text"
            name="full_name"
            onChange={changeHandler}
            placeholder="Your Name"
            style={inputStyles}
            onFocus={focusEffect}
            onBlur={blurEffect}
          />
          {validator.message('full_name', forms.full_name, 'required|alpha_space') && (
            <div style={errorStyles}>
              {validator.message('full_name', forms.full_name, 'required|alpha_space')}
            </div>
          )}
        </div>

        <div style={{ flex: '1 1 48%' }}>
          <input
            value={forms.email}
            type="email"
            name="email"
            onChange={changeHandler}
            placeholder="Your Email"
            style={inputStyles}
            onFocus={focusEffect}
            onBlur={blurEffect}
          />
          {validator.message('email', forms.email, 'required|email') && (
            <div style={errorStyles}>
              {validator.message('email', forms.email, 'required|email')}
            </div>
          )}
        </div>

        <div style={{ flex: '1 1 48%' }}>
          <input
            value={forms.phone}
            type="text"
            name="phone"
            onChange={changeHandler}
            placeholder="Your Phone"
            style={inputStyles}
            onFocus={focusEffect}
            onBlur={blurEffect}
          />
          {validator.message('phone', forms.phone, 'string') && (
            <div style={errorStyles}>
              {validator.message('phone', forms.phone, 'string')}
            </div>
          )}
        </div>

        <div style={{ flex: '1 1 100%' }}>
          <textarea
            value={forms.message}
            name="message"
            onChange={changeHandler}
            placeholder="Message"
            style={textareaStyles}
            onFocus={focusEffect}
            onBlur={blurEffect}
          />
          {validator.message('message', forms.message, 'required') && (
            <div style={errorStyles}>
              {validator.message('message', forms.message, 'required')}
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button
          type="submit"
          style={buttonStyles}
          disabled={loading}
          onMouseEnter={(e) => {
            e.target.style.boxShadow = '0 6px 16px rgba(0, 0, 139, 0.5)';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.boxShadow = '0 4px 10px rgba(0, 0, 139, 0.4)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {loading ? 'Sending...' : 'Submit Now'}
        </button>
      </div>

      {error && (
        <p style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{error}</p>
      )}
    </form>
  );
};

export default ContactForm;
